gx-designer-tool-breadcrumb {
  display: block;
  --item-margin: 3px;

  & .list {
    display: flex;
    align-items: flex-end;
    margin: 0;
    padding: 0;
    list-style: none;
    & .item {
      cursor: pointer;
      background-color: var(--color-accent-surface-elevation-1);
      padding: 3px 5px;
    }
  }
  &.location-top .list {
    flex-direction: column-reverse;
    & .item {
      margin-bottom: var(--item-margin);
    }
  }
  &.location-bottom .list {
    flex-direction: column;
    & .item {
      margin-top: var(--item-margin);
    }
  }
}
